import React from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import qs from 'query-string'
import { useQuery } from '@apollo/client'
import { Container, Logo, PreHeader } from '@scentregroup/ui'
import pagesHoc from '../pages-hoc'
import { getAlgoliaApiKeys } from '../../config'
import { useCountryContext, useEvolvedContext } from '../../context'
import { useUniversalHeaderCart } from '../../hooks/use-cart'
import { useUser } from '../../hooks/use-user'
import withCentreSelector from '../../containers/with-centre-selector'
import withGiftCards from '../../containers/with-gift-cards'
import withNationalHomepage from '../../containers/with-national-homepage'
import withProductCategories from '../../containers/with-product-categories'
import NationalFooter from '../../components/national-footer'
import { UniversalHeader } from '../../components/universal-header'
import { UniversalFooter } from '../../components/universal-footer'
import Header from './header'
import style from './index.module.scss'

const NavigationMenu = categories => {
  const topCategories = categories.filter(category => category.depth === 1)

  return topCategories.map(topCategory => ({
    title: topCategory.name,
    url: `/${topCategory.path}`,
    items: categories
      .filter(category => category.parent_id === topCategory.category_id)
      .map(category => ({
        url: `/${category.path}`,
        label: category.name,
      }))
      .concat([
        {
          url: `/${topCategory.path}?on_sale=true`,
          label: 'Sale Items',
        },
      ]),
  }))
}

const Shell = ({
  children,
  location,
  history,
  centres,
  giftCards,
  nationalExperienceNavLinks,
  nationalNavLinks,
  productCategories,
}) => {
  const isEvolved = useEvolvedContext()
  const country = useCountryContext()
  const cart = useUniversalHeaderCart()
  const { user } = useUser(isEvolved ? useQuery : undefined)
  const [navPath, setNavPath] = React.useState()

  const navigationMenu = React.useMemo(
    () => NavigationMenu(productCategories),
    [productCategories]
  )

  const searchQuery = React.useMemo(
    () => qs.parse(location.search).search_query,
    [location.search]
  )

  return (
    <>
      {isEvolved ? (
        <UniversalHeader
          Link={Link}
          country={country}
          centres={centres}
          giftCards={giftCards}
          cart={cart}
          user={user}
          pinnedLinks={{ items: nationalExperienceNavLinks }}
          nationalNav={nationalNavLinks}
          algoliaApiKeys={getAlgoliaApiKeys()}
          navPath={navPath}
        />
      ) : (
        <>
          <PreHeader colour="brand">
            <Link to="/" title="Home" className={style.preHeaderLogo}>
              <Logo />
            </Link>
          </PreHeader>
          <Header
            navigationMenu={navigationMenu}
            history={history}
            searchQuery={searchQuery}
          />
        </>
      )}
      <Container
        centred
        spaced
        className={classNames(style.productsContainer)}
        type="full"
      >
        {children}
      </Container>
      {isEvolved ? (
        <UniversalFooter
          Link={Link}
          country={country}
          onFindACentre={() => setNavPath(['find-a-centre'])}
        />
      ) : (
        <NationalFooter colour="brand" />
      )}
    </>
  )
}

Shell.propTypes = {
  children: PropTypes.node,
  location: PropTypes.object,
  history: PropTypes.object,
  centres: PropTypes.arrayOf(PropTypes.object),
  giftCards: PropTypes.object,
  nationalExperienceNavLinks: PropTypes.arrayOf(PropTypes.object),
  nationalNavLinks: PropTypes.object,
  productCategories: PropTypes.array,
}

const getMetaData = () => ({
  title: 'Products at Westfield',
  description: '',
})

export default withCentreSelector(
  withGiftCards(
    withNationalHomepage(withProductCategories(pagesHoc(Shell, getMetaData)))
  )
)
